import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getRejectJobListList = createAsyncThunk(
  "rejectJobList/getRejectJobListList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/cleaning/reject_job`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const rejectJobSlice = createSlice({
  name: "rejectJobList",
  initialState: {
    loading: false,
    rejectJobData: null,
    error: null,
  },
  reducers: {
    ResetRejectJob: (state) => {
      state.rejectJobData = null; // Clear old data
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRejectJobListList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRejectJobListList.fulfilled, (state, action) => {
        state.loading = false;
        state.rejectJobData = action.payload;
      })
      .addCase(getRejectJobListList.rejected, (state, action) => {
        state.loading = false;
        state.rejectJobData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetRejectJob } = rejectJobSlice.actions;
export default rejectJobSlice.reducer;
